<template>
	<div v-if="error.statusCode === 404" class="content">
		<div class="container-link-home">
			<nuxt-link to="/" class="link-home">{{ $t('error.back_to_home') }}</nuxt-link>
		</div>
	</div>
</template>

<script setup>
const { t } = useI18n()

useHead({
	title: t('header_title.errror'),
})

defineProps({
	error: {
		type: Object,
		required: true,
	},
})
</script>

<style scoped>
.content {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: flex-end;
	width: 100%;
	min-height: 100vh;
	background-image: url('assets/errorpictures/error-page.png');
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}

.container-link-home {
	margin-bottom: 100px;
}

.link-home {
	font-weight: bold;
	padding-top: 10px;
	padding-bottom: 10px;
	padding-right: 20px;
	padding-left: 20px;
	background-color: #130e4b;
	color: #ffffff;
	text-decoration: none;
	border-radius: 5px;
}

.link-home:hover {
	opacity: 0.9;
}
</style>
